import { render, staticRenderFns } from "./dpbox.vue?vue&type=template&id=a1f7a0e6&scoped=true&"
import script from "./dpbox.vue?vue&type=script&lang=js&"
export * from "./dpbox.vue?vue&type=script&lang=js&"
import style0 from "./dpbox.vue?vue&type=style&index=0&id=a1f7a0e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1f7a0e6",
  null
  
)

export default component.exports